import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { DataBl, ResponseContainerBL } from '@/types/containersBLType';

export const getContainersBL = async (bl: string): Promise<DataBl[]> => {
  try {
    const res = await apiClient.post<ResponseContainerBL>(
      Endpoints.AddContainersBL,
      {
        bl,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
